import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import { CustomizationField, fieldOptions } from 'modules/expenses/hooks/useExpensesCustomization'

interface DocumentTypeProps {
  documentType: string
  customizationFields: CustomizationField[]
}

export const DocumentType = ({ documentType, customizationFields }: DocumentTypeProps) => {
  const documentTypeOptions = fieldOptions('expense', 'document_type', customizationFields)
  const getDocumentTypeLabel = (documentType: string) => {
    const option = documentTypeOptions.find((el) => el.value === documentType)
    return option?.label || ''
  }
  return (
    <Box flexDirection="row" alignItems="center" gap="s6">
      <Icon.Medium icon="ticket" />
      <Text.Normal size="200">{getDocumentTypeLabel(documentType)}</Text.Normal>
    </Box>
  )
}
